import { CommonFieldsSchema } from 'domains/signupDirect/schemas/common';
import { z } from 'zod';
import { PrivatePayBilling, MedicaidBilling, MedicareBilling, CommercialInsuranceBilling } from './evaluationSchema';

// Modify the PrivatePayBilling to make stripeMethodId optional
export const PrivatePayBillingCustom = PrivatePayBilling.omit({ stripeMethodId: true }).extend({
  stripeMethodId: z.string().optional().nullable(),
});

const ScheduleInfo = z.object(
  {
    time: z.date(),
    timeZone: z.string(),
  },
  {
    message: 'Must pick a time slot for your consultation',
  },
);

export const NoInsurance = z.object({
  type: z.literal('no-insurance'),
});

export const ConsultationForm = CommonFieldsSchema.extend({
  consentToTerms: z.boolean().optional(),
  consultSchedule: ScheduleInfo,
  billingInfo: z.discriminatedUnion('type', [
    NoInsurance,
    PrivatePayBillingCustom,
    MedicaidBilling,
    MedicareBilling,
    CommercialInsuranceBilling,
  ]),
});

export type ConsultationFormType = z.infer<typeof ConsultationForm>;

export const consultationPaymentMethodIsInsurance = (paymentData: ConsultationFormType['billingInfo']) => {
  return (
    paymentData.type === 'insurance-commercial' ||
    paymentData.type === 'insurance-medicaid' ||
    paymentData.type === 'insurance-medicare'
  );
};
